import * as types from './actionTypes'

const initialState = {
	loading: false,
	getConsolidated: null,
	getEnergyConsumption: null,
	getNetworkEnergyConsumption: null,
	getOperationalEfficiency: null,
	getPredictionFault: null,
	getInsights: null

	
};

const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.RESET_STORE_USER:
			return initialState;
			
		case types.GET_CONSOLIDATED_REQUEST:
			return {
				...state,
				loading:true,
			};
		case types.GET_CONSOLIDATED_SUCCESS:
			return {
				...state,
				loading:false,
				getConsolidated: action.payload
			};
		case types.GET_CONSOLIDATED_ERROR:
			return {
				...state,
				loading:false,
				getConsolidated: null

			};

			case types.GET_ENERGY_CONSUMPTION_REQUEST:
			return {
				...state,
				loading:true,
			};
		case types.GET_ENERGY_CONSUMPTION_SUCCESS:
			return {
				...state,
				loading:false,
				getEnergyConsumption: action.payload
			};
		case types.GET_ENERGY_CONSUMPTION_ERROR:
			return {
				...state,
				loading:false,
				getEnergyConsumption: null

			};

			case types.GET_NETWORK_ENERGY_CONSUMPTION_REQUEST:
			return {
				...state,
				loading:true,
			};
		case types.GET_NETWORK_ENERGY_CONSUMPTION_SUCCESS:
			return {
				...state,
				loading:false,
				getNetworkEnergyConsumption: action.payload
			};
		case types.GET_NETWORK_ENERGY_CONSUMPTION_ERROR:
			return {
				...state,
				loading:false,
				getNetworkEnergyConsumption: null

			};

			case types.GET_OPERATIONAL_EFFICIENCY_REQUEST:
				return {
					...state,
					loading:true,
				};
			case types.GET_OPERATIONAL_EFFICIENCY_SUCCESS:
				return {
					...state,
					loading:false,
					getOperationalEfficiency: action.payload
				};
			case types.GET_OPERATIONAL_EFFICIENCY_ERROR:
				return {
					...state,
					loading:false,
					getOperationalEfficiency: null
	
				};

				case types.GET_PREDICTION_FAULT_REQUEST:
					return {
						...state,
						loading:true,
					};
				case types.GET_PREDICTION_FAULT_SUCCESS:
					return {
						...state,
						loading:false,
						getPredictionFault: action.payload
					};
				case types.GET_PREDICTION_FAULT_ERROR:
					return {
						...state,
						loading:false,
						getPredictionFault: null
		
					};
		
					case types.GET_INSIGHTS_REQUEST:
						return {
							...state,
							loading:true,
						};
					case types.GET_INSIGHTS_SUCCESS:
						return {
							...state,
							loading:false,
							getInsights: action.payload
						};
					case types.GET_INSIGHTS_ERROR:
						return {
							...state,
							loading:false,
							getInsights: null
			
						};
			
	
	
		default:
			return state
	}
};

export default userReducer
